import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import { BabackAccessLogView } from "@/shared-screens/baback-access-log/baback-access-log-view";
import useTranslation from "@babackapp/translations/use-translation";

/** Shop settings: the journal of Baback team access (BAB-3035). */
export default function BabackAccessLogPage() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const canRead = useViewerHasAtLeastAdminRights();

  return (
    <div className="w-full flex justify-center pt-16 px-4">
      <div className="w-full flex-1 max-w-[1100px] flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-semibold">{t("babackAccess.title")}</h1>
          <p className="text-sm text-muted-foreground">
            {t("babackAccess.description")}
          </p>
        </div>
        <BabackAccessLogView shopId={shop.id} canRead={canRead} />
      </div>
    </div>
  );
}
